import styled from "styled-components";
import {StickyNavigationMenuActiveIndicatorDefaultBox} from "./sticky-navigation-menu-active-indicator.default.box";

export const StickyNavigationMenuActiveIndicatorWsopBox = styled(StickyNavigationMenuActiveIndicatorDefaultBox)`
  &::after {
    background-position: -355px -306px;
  }
`;
